import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

import Toaster from "../../../components/common/Toaster";

import complianceService from "../../../services/complianceService";
import moment from "moment";

const CorHeader = ({ id, cor }) => {
  const [taxTypes, setTaxTypes] = useState([]);

  const fetchTaxTypes = useCallback(
    async (mounted) => {
      try {
        const result = await complianceService.getCORFormsAsync(id);
        const data = [...new Set(result.map((item) => item.tax_type))];

        if (mounted) setTaxTypes(data);
      } catch (ex) {
        Toaster.Error("Something went wrong.");
      }
    },
    [id]
  );

  useEffect(() => {
    let mounted = true;

    fetchTaxTypes(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchTaxTypes]);

  return (
    <div className="card p-0 mt-5">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-gray-500">Tax Index</h3>
        <p className="mt-1 text-sm text-gray-400"></p>
      </div>
      <div className="border-t">
        <dl>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-400">Account</dt>
            <dd className="mt-1 text-sm text-blue-500 sm:mt-0 sm:col-span-2">
              <Link to={`/accounts/${cor.account_id}`}>
                Dr. {cor.first_name} {cor.last_name}
              </Link>
            </dd>
          </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-400">OCN</dt>
            <dd className="mt-1 text-sm text-gray-500 sm:mt-0 sm:col-span-2">
              {cor.ocn}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-400">RDO</dt>
            <dd className="mt-1 text-sm text-gray-500 sm:mt-0 sm:col-span-2">
              {cor.rdo}
            </dd>
          </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-400">
              Date Generated
            </dt>
            <dd className="mt-1 text-sm text-gray-500 sm:mt-0 sm:col-span-2">
              {moment(cor.date_generated).format("LL")}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-400">Tax Types</dt>
            <dd className="mt-1 text-sm text-gray-500 space-x-2 sm:mt-0 sm:col-span-2">
              {taxTypes.map((item, index) => {
                return (
                  <span key={index} className="p-1 border rounded text-xs">
                    {item}
                  </span>
                );
              })}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default CorHeader;
